module.exports = __webpack_public_path__ + "static/media/bg_new-min.7738cf47.png";